import classNames from "classnames/bind"
import PropTypes from "prop-types"
import React from "react"
import { useLocation } from "react-router-dom"

import { useTranslate } from "context/translateContext"
import tickIcon from "shared/images/tick_plan.svg"

import gridStyles from "../../../components/Plans.module.css"


const cx = classNames.bind(gridStyles)

const bodyClass = cx("row", "planCell")

const Advertising = ({ plans }) => {
  const { t: translate } = useTranslate()
  const location = useLocation()
  const type = location.pathname.split("/")[2]
  return (
    <>
      <div className={cx(bodyClass, "mobileHeading", "featureDescriptionCell")}>
        <p className={gridStyles.sectionTitle}>{translate("Advertising")}</p>
        <p className="w500 fs-16 m-b-0">
          {translate("Get top of search results")}
        </p>
        <p className={gridStyles.sectionHelperText}>
          {type === "domestic"
            ? translate(
              "Automated creation and management of profitable ad campaigns across domestic marketplaces"
            )
            : translate(
              "Automated creation and management of profitable ad campaigns across international marketplaces"
            )}
        </p>
      </div>
      {plans.map(plan => (
        <div
          key={`ADVERTISING_${plan.name}`}
          className={cx(
            bodyClass,
            "flex-container",
            "f-j-center",
            "f-a-center"
          )}
        >
          <img src={tickIcon} className={gridStyles.tickIcon} alt="Tick icon" />
        </div>
      ))}
    </>
  )
}

Advertising.propTypes = { plans: PropTypes.array }
Advertising.defaultProps = { plans: [] }

export default Advertising
